import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { FamilyStore } from "./FamilyStore";

export class AddChildStore {
  store: FamilyStore;
  showDlg = false;
  loading = false;
  saving = false;
  isNew = false;
  orgs: any[] = [];
  keyword = "";
  loadingSchool = false;

  newStore: AddNewChildStore;
  existingStore: AddExistingChildStore;
  constructor(store: FamilyStore) {
    makeAutoObservable(this, {});
    this.store = store;
    this.newStore = new AddNewChildStore(this);
    this.existingStore = new AddExistingChildStore(this);
    // this.init();
  }

  @action show() {
    this.isNew = false;
    this.existingStore.children = [];
    this.showDlg = true;
  }
  @action close() {
    this.showDlg = false;
  }

  @action init() {
    Api.org.orgDict({}).then((res) => {
      this.orgs = res.data.orgs.items;
    });
  }

  @action
  setKeyword(val) {
    this.keyword = val;

    if (!this.keyword.trim()) {
      this.orgs = [];
      this.loadingSchool = false;
      return;
    }

    this.loadingSchool = true;
    Api.org
      .orgDict({ keyword: this.keyword })
      .then((res) => {
        runInAction(() => {
          this.orgs = res.data.orgs.items;
        });
      })
      .finally(() => {
        this.loadingSchool = false;
      });
  }
}

export class AddNewChildStore {
  store: AddChildStore;

  schoolId: string | undefined = undefined;

  constructor(store: AddChildStore) {
    makeAutoObservable(this, {});
    this.store = store;
  }

  get grades() {
    return this.store.orgs.find((x: any) => x.id === this.schoolId)?.grades || [];
  }

  @action onSchool(val) {
    this.schoolId = val;
  }
}

export class AddExistingChildStore {
  store: AddChildStore;

  schoolId: string | undefined = undefined;
  loading = false;
  children: any[] = [];

  constructor(store: AddChildStore) {
    makeAutoObservable(this, {});
    this.store = store;
  }

  get grades() {
    return this.store.orgs.find((x: any) => x.id === this.schoolId)?.grades || [];
  }

  @action onSchool(val) {
    this.schoolId = val;
  }

  @action search(values) {
    this.loading = true;
    Api.child
      .children(values)
      .then((res) => {
        console.log("dd", res.data.children);
        runInAction(() => {
          this.children = res.data.children.items;
        });
      })
      .finally(() => (this.loading = false));
  }
}
